import React, { ChangeEvent, FC, useEffect, useState } from 'react';

import { FormDialog, InputField, TextfieldSelect } from '@Iot-Bee/standard-web-library';

import { InputLabel } from '@mui/material';
import { EditWebUser, NewWebuser, UserRole, userRoles, WebUser } from '../interfaces';

interface UserDialogProps {
  user?: WebUser;
  open: boolean;
  onClose: () => void;
  onSave: (user: EditWebUser | NewWebuser) => void;
}

const UserDialog: FC<UserDialogProps> = ({ user, open, onClose, onSave }) => {
  const [userFormData, setUserFormData] = useState<EditWebUser | NewWebuser>(
    user !== undefined
      ? { ...user, currentPassword: '', newPassword: '' }
      : { name: '', email: '', role: userRoles[0], currentPassword: '', newPassword: '' }
  );

  useEffect(() => {
    if (user) {
      setUserFormData((state) => ({
        ...state,
        ...user,
      }));
    } else {
      setUserFormData({
        name: '',
        email: '',
        role: userRoles[0],
        currentPassword: '',
        newPassword: '',
      });
    }
  }, [user]);

  const isEdit = user !== undefined && 'id' in user;

  return (
    <FormDialog
      title="Manage user"
      buttonText={`${isEdit ? 'Edit' : 'Add'} user`}
      open={open}
      onClose={onClose}
      onSave={() => {
        onSave(userFormData);
      }}
      maxWidth="xs"
    >
      <InputField
        label="Name"
        value={userFormData.name}
        onChange={(value) =>
          setUserFormData((state) => ({
            ...state,
            name: value,
          }))
        }
        sx={{ pb: 5, display: 'block' }}
        required
      />
      <InputField
        label="E-mail"
        type="email"
        value={userFormData.email}
        readOnly={true}
        onChange={(value) =>
          setUserFormData((state) => ({
            ...state,
            email: value,
          }))
        }
        sx={{ pb: 5, display: 'block' }}
        required
      />
      <InputLabel sx={{ pb: 1 }}>Role *</InputLabel>
      <TextfieldSelect
        value={userFormData.role}
        options={userRoles}
        onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
          setUserFormData((state) => ({
            ...state,
            role: e.target.value as UserRole,
          }))
        }
        sx={{ pb: 5 }}
        fullWidth
        required
      />
      <InputField
        label={user !== undefined ? 'Current Password' : 'Password'}
        type="password"
        value={userFormData.currentPassword}
        sx={{ pb: 5, display: 'block' }}
        onChange={(value) =>
          setUserFormData((state) => ({
            ...state,
            currentPassword: value,
          }))
        }
        required
      />
      {isEdit && (
        <InputField
          label="New Password"
          type="password"
          value={'newPassword' in userFormData ? userFormData.newPassword : ''}
          sx={{ pb: 5, display: 'block' }}
          onChange={(value) =>
            setUserFormData((state) => ({
              ...state,
              newPassword: value,
            }))
          }
        />
      )}
    </FormDialog>
  );
};

export default UserDialog;
